module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-3-212abb4be5676b4b6fe824b39bf5d660.svg";